export default {
  notificationDropdown: document.querySelector('#notificationDropdown'),
  body: document.querySelector('body'),
  open() {
    this.body.classList.add('notificationDropdown-expanded');
  },
  close() {
    this.body.classList.remove('notificationDropdown-expanded');
  },
  init() {
    if (this.notificationDropdown) {
      this.notificationDropdown.addEventListener('show.bs.dropdown', () => {
        this.open();
      });
      this.notificationDropdown.addEventListener('hide.bs.dropdown', () => {
        this.close();
      });
    }
  }
}
